
(function documentTypeControllerDefinition() {
    'use strict';

    angular.module('DocumentType')
        .controller('DocumentTypeImportSettingsController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminDocumentTypeService', 'authExtend',
        function documentTypeController($scope, config, $state, $translate, errors, $stateParams, adminDocumentTypeService, authExtend) {

            $scope.title = 'Import Settings Title';

            adminDocumentTypeService.getById($stateParams.id, 'Put').then(function (result) {
                $scope.documentType = result;
            }, function (error) {
                errors.showError(error);
                $state.go('document-type-find');
            });

            $scope.save = function () {

                if (!$scope.documentTypeForm.$valid) {
                    $scope.documentTypeForm.$setSubmitted();
                    errors.showError('VerifyFormData');
                    return;
                }

                adminDocumentTypeService.modify($scope.documentType).then(function () {
                    $state.go('document-type-find');
                },
                    function (error) {
                        errors.showError(error);
                    });
            };

            $scope.cancel = function () {
                $state.go('document-type-find');
            };

        }
        ]);
})();